<template>
  <button
    type="button"
    class="btn btn__select btn--arrow"
  ><slot>Continue</slot>
  </button>
</template>

<script>
export default {
}
</script>
